import React, {Component} from 'react';
import PropTypes from 'prop-types';
import urlHandler from '../../utils/urlHandler';
import validation from '../../utils/validation';
import data from '../../utils/data';
import ReactModal from 'react-modal';
import {Validators, FormBuilder, FieldControl, FieldGroup} from 'react-reactive-form';
import renderers from './forms/renderers';
import ArrayEditControl from './forms/ArrayEditControl';
import LocationEditControl from './forms/MetadataEditControl';
import LinkEditControl from './forms/LinkEditControl';
import LinkEditControl2 from './forms/LinkEditControl2';
import LanguageFieldsEditControl from './forms/LanguageFieldsEditControl';
import PhoneNumbersEditControl from './forms/PhoneNumbersEditControl';
import EmailsEditControl from './forms/EmailsEditControl';
import IdentifiersEditControl from './forms/IdentifiersEditControl';
import CitizenshipsEditControl from './forms/CitizenshipsEditControl';
import LinkEditControlBase from './forms/LinkEditControlBase';
import MetadataEditControl from './forms/MetadataEditControl';
import ReactTooltip from 'react-tooltip';
import LinkLookupControl from './forms/LinkLookupControl';


class CreateProgress extends Component {
    render() {
        return (
            <span className="kbedit-updating">
                <span className="fa fa-circle-o-notch fa-spin"></span>&nbsp;Creating ...
            </span>
        );
    }
}

class CustomEntityCreateDialog extends Component {
    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onReset = this.onReset.bind(this);
        this.onScrollTo = this.onScrollTo.bind(this);
        this.updateHeightDimensions = this.updateHeightDimensions.bind(this);
        this.initForm = this.initForm.bind(this);
        this.onEntityTypeChange = this.onEntityTypeChange.bind(this);
        this.onEntityLabelChange = this.onEntityLabelChange.bind(this);

        this.state = {
            height: 0,
            error: null,
            creating: false,
            entityType:'PERSON',
            label:''
        };
    };

    initForm() {
        
        this.myForm = FormBuilder.group({
            matchText:['', [Validators.required, Validators.minLength(2)]],
            entityType:['PERSON', [Validators.required, Validators.pattern(validation.customTypePattern), Validators.minLength(2)]],
            action:['ADD', Validators.required],
            label:'',
            metadata: FormBuilder.group(MetadataEditControl.initMetadata(null)),
            exactMatch:false
        });
    }

    componentDidMount() {
        ReactModal.setAppElement('#rm_CustomEntityCreateDialog');
        this.updateHeightDimensions();
        this.initForm();
    }

    componentWillReceiveProps(newProps) {
        if (this.myForm) {
            this.initForm();
        }
    }

    updateHeightDimensions() {
        this.setState({
            height: window.innerHeight - 75 - (window.innerHeight / 5)
        })
    }

    close(cancelled=true) {
        this.setState({
            creating: false,
            error: null
        },() => {
            if (this.props.onCreate) {
                this.props.onCreate(cancelled);
            }
        })
    };


    onSubmit(e) {
        e.preventDefault();
        this.setState({
            creating: true
        }, ()=> {
            if (this.myForm.valid) {

                var formValues = Object.assign({}, this.myForm.getRawValue());
                if (formValues.entityType !== 'PERSON' && formValues.metadata){
                    delete formValues.metadata;
                }
                if (formValues.action === 'REMOVE'){
                    formValues.ignoreSubtype = true;
                }
                // Remove all empty fields from the object
                validation.removeEmptyItems(formValues)
                urlHandler.sendCustomEntityCreateRequest(formValues, (resp, status) => {
                    if (status != 200 || (resp && resp.code != 200)) {
                        let error = decodeURIComponent(resp.error_message);
                        error = error ? error.substring(error.indexOf('-')+1).trim() : '';
                        error = (error === undefined || error === 'undefined') ? '' : error;
                        if (!error && status == 504) {
                            error ='FFT Gateway timed out. Contact your administrator. Please try again later.' 
                        }
                        else if(!error) {
                            error = 'There was an error creating the organization. Please try again later.';
                        }                        
                        this.setState({
                            error,
                            creating: false
                        }, () => {
                            this.onScrollTo('err_msg');
                        })   
                    } else {
                        this.close(false);
                    }
                })
            } else {
                this.setState({
                    error: 'There are errors below.',
                    creating: false
                }, () => {
                    this.onScrollTo('err_msg');
                })
            }
        });
    }

    onReset(cancelled=true) {
        this.close(cancelled);
    }

    onScrollTo(anchor) {
        document.getElementById(anchor).scrollIntoView({block: 'start', behavior: 'smooth'});
    }

    onEntityTypeChange(v){
        this.myForm.get('entityType').setValue(v)
        this.setState({'entityType':v})
    }
    
    onEntityLabelChange(v){
        this.myForm.get('label').setValue(v)
        this.setState({'label':v})
    }

    // future: 
    // // {
    // //     // sidebar change Id to entry
    // //     // remove edit and just have options to add and delete
    // //     matchText on blur do validate and check for duplicate keys
    // //     export the json all entries
    // //     exactMatch: default false, 
    // //     ignoresubtype default true (do not expose, only use it for REMOVE do not use on ADD)
    // //     label (substitute as finchID, then go look up label in the background)
    // //     metadata (do this for person)

    // //     Add blurbs in form to explain what each of the fields means

    // // }

    render() {
        var genders = data.getGenders();
        var countries = data.getCountries();
        var employerTypes = data.getEmployerTypes();
        var ownerTypes = data.getOwnerTypes();

        const styles = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1000'
            },
            content : {
                top         : '0',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                paddingBottom: '5px',
                transform   : 'translate(-50%)',
                maxWidth    : '70%',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }
        return (
            <div id="rm_CustomEntityCreateDialog">
                <ReactModal ref="createId" 
                    isOpen={this.props.show}
                    contentLabel="Create Custom Entity"
                    onRequestClose={this.close} 
                    style={styles}
                    shouldCloseOnOverlayClick={false}
                    closeTimeoutMS={1000}>
                    <div className="kbedit">
                        <div className="kbedit-header">
                            <span className="header-text">Create Custom Entity</span>
                        </div> 

                        <div className="kbedit-content" style={{maxHeight: `${this.state.height}px`}}>

                        <div className="kbedit-controls-wrapper">
                            <div className="kbedit-static-menu">
                                {/* using tooltips is bad for accessiblity consider adding alt tags as well */}
                                <span data-tip data-for="matchText" className="fa fa-info-circle">&nbsp;</span><span onClick={() => {this.onScrollTo('bm_match_text')}}>Match Text</span><br/>
                                <ReactTooltip id="matchText" 
                                        type="dark"
                                        effect="solid" 
                                        place="right">
                                        The string to search for in documents to match.
                                </ReactTooltip>

                                <span data-tip data-for="entityType" className="fa fa-info-circle">&nbsp;</span><span onClick={() => {this.onScrollTo('bm_entity_type')}}>Entity Type</span><br/>
                                <ReactTooltip id="entityType"  
                                        type="dark"
                                        effect="solid" 
                                        place="right">
                                        The entity's type, can be a Finch entity type or a custom one.<br/>
                                        Can only contain capital leters, "_" and "/".<br/>
                                        Type must start and end with letter(s). <br/>
                                        "/" and "_" must be immediately preceded and followed by letter(s).
                                </ReactTooltip>

                                <span data-tip data-for="action" className="fa fa-info-circle">&nbsp;</span><span onClick={() => {this.onScrollTo('bm_action')}}>Action</span><br/>
                                <ReactTooltip id="action" 
                                        type="dark"
                                        effect="solid" 
                                        place="right">
                                        Whether or not to ADD or REMOVE the entity from documents.<br/>
                                        If ADD will attempt to find the entity in documents and tag it.<br/>
                                        If REMOVE when the entity is found in a document it and its tags will be removed.
                                </ReactTooltip>

                                <span data-tip data-for="label" className="fa fa-info-circle">&nbsp;</span><span onClick={() => {this.onScrollTo('bm_label')}}>Label (FinchId)</span><br/>
                                <ReactTooltip id="label" 
                                        type="dark"
                                        effect="solid" 
                                        place="right">
                                        Normalizes and assists in using/displaying non-disambiguated entities, also used to improve disambiguation.<br/>
                                        Search the Finch Knowledgebase and select an entity and associated label using the link functionality.
                                </ReactTooltip>

                                {this.state.entityType === 'PERSON' && 
                                    <div>
                                        <span data-tip data-for="metadata" className="fa fa-info-circle">&nbsp;</span><span onClick={() => {this.onScrollTo('bm_metadata')}}>Metadata</span><br/>
                                        <ReactTooltip id="metadata" 
                                                type="dark"
                                                effect="solid" 
                                                place="right">
                                                Used to represent other entity attributes. In this UI only utilized to supply the first and last name for PERSON custom entities. 
                                        </ReactTooltip>
                                    </div>
                                }

                                <span data-tip data-for="exact" className="fa fa-info-circle">&nbsp;</span><span onClick={() => {this.onScrollTo('bm_exact_match')}}>Exact Match</span><br/>
                                <ReactTooltip id="exact" 
                                        type="dark"
                                        effect="solid" 
                                        place="right">
                                        If checked the extraction must match the specified matchText exactly.<br/>
                                        If unchecked case or punctuation may be ignored.
                                </ReactTooltip>
                            </div>
                            <div className="kbedit-controls-list">
                                {this.state.error &&
                                    <div className="kbedit-error" id="err_msg">
                                        {this.state.error || ''}
                                    </div>
                                }

                                <FieldGroup
                                    control={this.myForm}
                                    render={({ pristine, value, invalid}) => (
                                        <div className="kbedit-nav-items">
                                            <div id="bm_match_text">
                                                <FieldControl name='matchText' render={renderers.textBox} meta={{label: 'Match Text', placeholder: 'Enter text'}}/>
                                            </div>
                                            <div id="bm_entity_type">
                                                <FieldControl name='entityType' render={renderers.comboBox} meta={{label: 'Entity Type', placeholder: 'Enter text', onSelectChange: this.onEntityTypeChange, onTextChange: this.onEntityTypeChange, items: ['PERSON', 'ORGANIZATION', 'THING']}}/>
                                            </div>
                                            <div id="bm_action">
                                                <FieldControl name='action' render={renderers.selectBox} meta={{label: 'Action', items: ['ADD', 'REMOVE']}}/>
                                            </div>     
                                            <div id="bm_label">
                                                <FieldControl name='label' render={renderers.linkTextBox} meta={{label:'Label', getQueryValue:()=>this.myForm.get('label').value, name:'label', form:this.myForm, placeholder: 'Enter Label', onChange:(v)=>this.myForm.get('label').setValue(v)}}/>
                                            </div>
                                            {this.state.entityType=== 'PERSON' && <div id="bm_metadata">
                                                <MetadataEditControl name='metadata' label='Metadata' form={this.myForm} />
                                            </div>}
                                            <div id="bm_exact_match">
                                                <FieldControl name='exactMatch' render={renderers.checkBox} meta={{label: 'Exact Match', items: ['ADD', 'REMOVE']}}/>
                                            </div> 
                                           

                                        </div>
                                    )}
                                />
                            </div>
                        </div>

                        </div>
                        <div className="kbedit-footer">
                            {this.state.creating ? <CreateProgress /> : null}
                            <button type="button" className="kbedit-default-button" onClick={this.onSubmit}>Create</button>
                            <button type="button" className="kbedit-default-button" onClick={this.onReset}>Cancel</button>
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    };
}

CustomEntityCreateDialog.propTypes = {
    show: PropTypes.bool.isRequired,
    onCreate: PropTypes.func
};

export default CustomEntityCreateDialog;


